const $             = require('jquery');
const _             = require('underscore');
const { icon }      = require('@fortawesome/fontawesome-svg-core');
const ellipsis      = require('../util/ellipsis');
const tpl           = require('../util/template');
const evtout        = require('../evtout');
const platform      = require('../platform');

const faIconOpts  = { classes: ['fa-icon'] };
const fa = {
  generic: require('@fortawesome/pro-duotone-svg-icons/faFileAlt').definition,
  doc: require('@fortawesome/pro-duotone-svg-icons/faFileWord').definition,
  docx: require('@fortawesome/pro-duotone-svg-icons/faFileWord').definition,
  jpg: require('@fortawesome/pro-duotone-svg-icons/faFileImage').definition,
  jpeg: require('@fortawesome/pro-duotone-svg-icons/faFileImage').definition,
  png: require('@fortawesome/pro-duotone-svg-icons/faFileImage').definition,
  mp3: require('@fortawesome/pro-duotone-svg-icons/faFileAudio').definition,
  mp4: require('@fortawesome/pro-duotone-svg-icons/faFileVideo').definition,
  pdf: require('@fortawesome/pro-duotone-svg-icons/faFilePdf').definition,
  csv: require('@fortawesome/pro-duotone-svg-icons/faFileSpreadsheet').definition,
  xml: require('@fortawesome/pro-duotone-svg-icons/faFileCode').definition,
  xls: require('@fortawesome/pro-duotone-svg-icons/faFileExcel').definition,
  xlsx: require('@fortawesome/pro-duotone-svg-icons/faFileExcel').definition,
  ppt: require('@fortawesome/pro-duotone-svg-icons/faFilePowerpoint').definition,
  pptx: require('@fortawesome/pro-duotone-svg-icons/faFilePowerpoint').definition
};

function compile(data) {
  if (!data.supplements.length) {
    return $('<div class="supplement-list"></div>');
  }

  let supplements = _.partition(data.supplements, s => s.personal)
  supplements.forEach(arr => arr.sort((a, b) => a.index - b.index))
  supplements = _.flatten(supplements);

  const elem = $(`
    <div class="supplement-list">
      ${supplements.map(sup => {
        let type = sup.type.toLowerCase();
        return `
          <div class="supplement ${type}" idx="${sup.index}" downloaded="${!!sup.localPath}">
            <div class="thumb">
              ${icon(fa[type] || fa.generic, faIconOpts).html}
            </div>
            <span class="description" data-tippy-content="${ellipsis(sup.description, 1021)}">
              <b>${sup.caption}
                <span>
                  (${sup.type.toUpperCase()}${isNaN(parseInt(sup.pages)) ? '' : ` - ${sup.pages} Pages`})
                </span>
              </b>
              ${tpl.if(sup.description, () => `
                <span><b> | </b>${sup.description}</span>
              `)}
            </span>
          </div>`;
      }).join('')}
    </div>
  `);

  let loader = $(`
    <div class="loading-more">
      <div class="loader-inner ball-pulse">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  `).prependTo(elem);

  elem.find('.supplement').each(function(idx) {
    let sup = supplements[idx];
    let thumb = sup.thumb;
    if (thumb && thumb[0]) {
      let img = new Image();
      img.onload = () => {
        $(this).find('.thumb').append(img);
        setProcessed.call(this, 'true');
      };
      img.onerror = () => setProcessed.call(this, 'false');
      img.src = thumb[0];
    } else {
      setProcessed.call(this, 'false');
    }

    $(this).click(e => {
      if (platform.app) {
        // e = _.omit(e.originalEvent, 'type');
        // TODO: use $.Event(eventName, e) for desktop
        if (sup.hash && sup.personal) {
          evtout.trigger('read-supplement', [sup]);
        } else {
          evtout.trigger('open-supplement', [sup]);
        }
      } else if (sup.viewer_pdf) {
        evtout.trigger('read-supplement', [sup]);
      } else {
        evtout.trigger('open-supplement', [sup]);
      }
    });
  });

  function setProcessed(value) {
    $(this).attr('processed', value);
    removeLoader();
  }

  function removeLoader() {
    if (!loader) return;
    loader.remove();
    loader = null;
  }

  return elem;
}

module.exports = { compile };
